import React from 'react';
import styled, { css } from 'styled-components';
import { TableCell } from '~/components/organism/Table/types';
import { cellProps } from '~/components/organism/Table/utils/propGetters';
import { restrictedFields } from '~/components/organism/Table/constants';
import { useLocation } from '@gatsbyjs/reach-router';
import useViewingModeProps from '~/hooks/useViewingModeProps';

type Props = {
  cell: TableCell<any>;
  allowFieldCopying?: boolean;
};

const RowCell: React.FCC<Props> = ({ cell, allowFieldCopying }) => {
  const location = useLocation();
  const tdCellPropsInitial = cell.getCellProps(cellProps);
  const viewingModeProps = useViewingModeProps();
  const tdCellProps = {
    ...tdCellPropsInitial,
    style: {
      ...tdCellPropsInitial.style,
      minWidth: tdCellPropsInitial.style.width,
    },
  };

  const isOnFlows = location.pathname.includes('flows');

  return (
    <StyledTd
      {...tdCellProps}
      key={tdCellProps.key}
      data-testid={cell.column.dataTestId}
      onClick={e => allowFieldCopying && e.stopPropagation()}
      data-redacted={
        viewingModeProps['data-redacted'] &&
        'id' in cell.column &&
        restrictedFields.includes(cell.column.id as string) &&
        !isOnFlows
      }
    >
      {cell.render('Cell')}
    </StyledTd>
  );
};

const StyledTd = styled.div<{}>`
  display: flex;
  align-items: center;
  align-content: center;
  word-break: break-word;
  ${'' /* Required for absolutely positioned resizer */}
  position: relative;

  ${({ theme }) => css`
    padding: 0 ${theme.space('xxs')};
    font-size: ${theme.fontSize('s')};
  `};
`;

export default RowCell;
